module.exports = __webpack_public_path__ + "img/duban.9a5f5bac.png";